import { render, staticRenderFns } from "./secteurPop.vue?vue&type=template&id=c642abaa&scoped=true"
import script from "./secteurPop.vue?vue&type=script&lang=js"
export * from "./secteurPop.vue?vue&type=script&lang=js"
import style0 from "./secteurPop.vue?vue&type=style&index=0&id=c642abaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c642abaa",
  null
  
)

export default component.exports